<template>
	<div id="defaultLayout" ref="screen">
		
			<RouterView />
			<WalletSignatureModal v-if="modals.showWalletSignatureModal" />
		
	</div>


</template>

<script lang="ts">
/* eslint-disable no-undef */
import { RouterLink, RouterView } from 'vue-router'

/* @group Components_Layout */
/*
  <h4> <b> Default Application Layout </b> </h4>
  <br>
  <br> Implements:
  <br> - Header Component
  <br> - Router Views as slot - /views folder components
  <br> - Shows message "Not optimized for small screens" in case window size < 1024 pixels
  <br>
  <br> Functionality:
  <br> - Application initialization:
  <br>    -> Refresh Token auth to get user data
  <br>    -> Get leaderboard portfolios
  <br>    -> Get all markets

  <br> - Refresh Interval - Initialization method called every 10 minutes
*/
import { defineComponent } from 'vue'
import WalletSignatureModal from '@/components/modals/WalletSignatureModal.vue';
import { mapState } from 'pinia';
import { useModalsStore } from '@/store/modules/modals';

export default defineComponent({
	name: 'AuthLayout',
	components: {
		WalletSignatureModal:WalletSignatureModal as any,

	},
	data() {
		return {

		};
	},
	computed: {
		...mapState(useModalsStore, {
			anyModalOpen: (state) => state.anyModalOpen,
			modals: (state) => state,
		}),

	},
	watch: {

	},
	async created() {
		
	},
	beforeMount() {
		
	},
	mounted() {
		


	},
	updated() {
	
	},
	unmounted() {
		
	},
	methods: {
		
		formAction() { },
	}
});
</script>
<style scoped>
.desktop-container {
	display: flex;
	min-height: 100vh;
	padding-top: 0 !important;
	max-width: 1440px;
	margin-left: auto;
	margin-right: auto;

}

.app-view-desktop {

	max-width: 1070px;
	margin-left: auto;
	margin-right: auto;

}


.dashboard-container {
	padding-top: 70px;
	width: 100%;
	padding-left: 40px;
	padding-right: 40px;
}

.notification-offset-def {
	margin-top: 15px;
}

.lang-notify {
	padding: 10px;
	font-size: 13px;
	background: #fff;
}

@media screen and (min-width: 769px) {
	.dashboard-container {
		padding-left: 40px;
		width: 100%;
		padding-right: 40px;
	}
}

@media screen and (max-width: 768px) {
	.dashboard-container {
		padding-right: 20px;
		padding-left: 20px;
		padding-top: 70px;
	}
}

.dashboard-container-desktop {
	width: 100%;
	padding-top: 80px;

}


.hidden-desktop {
	display: none;
}
</style>